module.exports = __webpack_public_path__ + "static/guilt-proud-meter-c042ab090e7c045c9dad13e2624582f1.gif";